<!--
 * @Author: Latte
 * @Date: 2022-01-19 17:53:27
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-20 15:37:47
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\cloudTeaching\resourcePreview\fileList\index.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-button type="primary" icon="el-icon-upload" size="small">
          上传
        </el-button>
        <el-button
          plain
          icon="el-icon-folder"
          size="small"
          @click="handleAddType"
        >
          新建类型
        </el-button>
      </div>
    </div>
    <el-table
      :data="fileList"
      v-loading="loading"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      border
    >
      <el-table-column
        label="文件名"
        prop="fileName"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.isSet">
              <i class="el-icon-folder-opened" style="color: #ffb848"></i>
              <el-input
                ref="inputRef"
                v-model="scope.row.fileName"
                size="small"
                style="margin: 0 10px; width: 50%"
              ></el-input>
              <el-button
                size="mini"
                class="el-icon-check"
                style="color: #129800"
                @click.stop="handleCreateType(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                class="el-icon-close"
                style="color: #ee1200"
                @click.stop="handleCancel(scope.row)"
              ></el-button>
            </div>
            <div v-else>
              <i class="el-icon-folder-opened" style="color: #ffb848"></i>
              <a :href="scope.row.url" target="_blank" style="color: #2a6496">{{
                scope.row.fileName
              }}</a>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="描述"
        prop="desc"
        align="center"
      ></el-table-column>
      <el-table-column
        label="创建日期"
        prop="createTime"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.stop="handleDownload(scope.row)"
          >
            下载
          </el-button>
          <el-button type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "fileList",

  components: {},

  mixins: [],

  props: {},

  data() {
    return {
      loading: false,
      fileList: [
        {
          fileName: "小儿肺炎诊断 B超更安全准确.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
        {
          fileName: "儿童纵隔超声检查.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
        {
          fileName: "新生儿肺部疾病的超声诊断.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
        {
          fileName: "小儿超声诊断学.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
        {
          fileName: "多普勒超声评价心功能的新指数—Tei指数.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
        {
          fileName: "超声学检查诊治肺结核的首选.doc",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152",
        },
      ],
    };
  },

  provide() {},

  inject: [],

  watch: {},

  computed: {},

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  methods: {
    handleDownload(row) {
      window.location.href =
        "https://test.cloud.siui.com/pdf-viewer/web/viewer.html?file=https://test.cloud.siui.com/SliderImage/Banners/1005703/1642473404345_1642473432152.pdf";
    },
  },
};
</script> 


<style scoped>
</style>
